!function (t, e) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : t.Mercury = e();
}(this, function () {
  "use strict";

  function t() {
    throw new Error("Dynamic requires are not currently supported by rollup-plugin-commonjs");
  }
  function e(t, e) {
    return e = {
      exports: {}
    }, t(e, e.exports), e.exports;
  }
  function n(t, e) {
    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
  }
  var r = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {},
    o = e(function (t, e) {
      !function (e, n) {
        t.exports = n();
      }(0, function () {
        return function (t) {
          function e(r) {
            if (n[r]) return n[r].exports;
            var o = n[r] = {
              exports: {},
              id: r,
              loaded: !1
            };
            return t[r].call(o.exports, o, o.exports, e), o.loaded = !0, o.exports;
          }
          var n = {};
          return e.m = t, e.c = n, e.p = "", e(0);
        }([function (t, e, n) {
          t.exports = n(1);
        }, function (t, e, n) {
          function r(t) {
            var e = new u(t),
              n = i(u.prototype.request, e);
            return o.extend(n, u.prototype, e), o.extend(n, e), n;
          }
          var o = n(2),
            i = n(3),
            u = n(5),
            s = n(6),
            a = r(s);
          a.Axios = u, a.create = function (t) {
            return r(o.merge(s, t));
          }, a.Cancel = n(23), a.CancelToken = n(24), a.isCancel = n(20), a.all = function (t) {
            return Promise.all(t);
          }, a.spread = n(25), t.exports = a, t.exports.default = a;
        }, function (t, e, n) {
          function r(t) {
            return "[object Array]" === f.call(t);
          }
          function o(t) {
            return null !== t && "object" == typeof t;
          }
          function i(t) {
            return "[object Function]" === f.call(t);
          }
          function u(t, e) {
            if (null !== t && void 0 !== t) if ("object" == typeof t || r(t) || (t = [t]), r(t)) for (var n = 0, o = t.length; n < o; n++) e.call(null, t[n], n, t);else for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && e.call(null, t[i], i, t);
          }
          function s() {
            for (var t = {}, e = 0, n = arguments.length; e < n; e++) u(arguments[e], function (e, n) {
              "object" == typeof t[n] && "object" == typeof e ? t[n] = s(t[n], e) : t[n] = e;
            });
            return t;
          }
          var a = n(3),
            c = n(4),
            f = Object.prototype.toString;
          t.exports = {
            isArray: r,
            isArrayBuffer: function (t) {
              return "[object ArrayBuffer]" === f.call(t);
            },
            isBuffer: c,
            isFormData: function (t) {
              return "undefined" != typeof FormData && t instanceof FormData;
            },
            isArrayBufferView: function (t) {
              return "undefined" != typeof ArrayBuffer && ArrayBuffer.isView ? ArrayBuffer.isView(t) : t && t.buffer && t.buffer instanceof ArrayBuffer;
            },
            isString: function (t) {
              return "string" == typeof t;
            },
            isNumber: function (t) {
              return "number" == typeof t;
            },
            isObject: o,
            isUndefined: function (t) {
              return void 0 === t;
            },
            isDate: function (t) {
              return "[object Date]" === f.call(t);
            },
            isFile: function (t) {
              return "[object File]" === f.call(t);
            },
            isBlob: function (t) {
              return "[object Blob]" === f.call(t);
            },
            isFunction: i,
            isStream: function (t) {
              return o(t) && i(t.pipe);
            },
            isURLSearchParams: function (t) {
              return "undefined" != typeof URLSearchParams && t instanceof URLSearchParams;
            },
            isStandardBrowserEnv: function () {
              return ("undefined" == typeof navigator || "ReactNative" !== navigator.product) && "undefined" != typeof window && "undefined" != typeof document;
            },
            forEach: u,
            merge: s,
            extend: function (t, e, n) {
              return u(e, function (e, r) {
                t[r] = n && "function" == typeof e ? a(e, n) : e;
              }), t;
            },
            trim: function (t) {
              return t.replace(/^\s*/, "").replace(/\s*$/, "");
            }
          };
        }, function (t, e) {
          t.exports = function (t, e) {
            return function () {
              for (var n = new Array(arguments.length), r = 0; r < n.length; r++) n[r] = arguments[r];
              return t.apply(e, n);
            };
          };
        }, function (t, e) {
          function n(t) {
            return !!t.constructor && "function" == typeof t.constructor.isBuffer && t.constructor.isBuffer(t);
          }
          function r(t) {
            return "function" == typeof t.readFloatLE && "function" == typeof t.slice && n(t.slice(0, 0));
          }
          t.exports = function (t) {
            return null != t && (n(t) || r(t) || !!t._isBuffer);
          };
        }, function (t, e, n) {
          function r(t) {
            this.defaults = t, this.interceptors = {
              request: new u(),
              response: new u()
            };
          }
          var o = n(6),
            i = n(2),
            u = n(17),
            s = n(18),
            a = n(21),
            c = n(22);
          r.prototype.request = function (t) {
            "string" == typeof t && (t = i.merge({
              url: arguments[0]
            }, arguments[1])), (t = i.merge(o, this.defaults, {
              method: "get"
            }, t)).method = t.method.toLowerCase(), t.baseURL && !a(t.url) && (t.url = c(t.baseURL, t.url));
            var e = [s, void 0],
              n = Promise.resolve(t);
            for (this.interceptors.request.forEach(function (t) {
              e.unshift(t.fulfilled, t.rejected);
            }), this.interceptors.response.forEach(function (t) {
              e.push(t.fulfilled, t.rejected);
            }); e.length;) n = n.then(e.shift(), e.shift());
            return n;
          }, i.forEach(["delete", "get", "head", "options"], function (t) {
            r.prototype[t] = function (e, n) {
              return this.request(i.merge(n || {}, {
                method: t,
                url: e
              }));
            };
          }), i.forEach(["post", "put", "patch"], function (t) {
            r.prototype[t] = function (e, n, r) {
              return this.request(i.merge(r || {}, {
                method: t,
                url: e,
                data: n
              }));
            };
          }), t.exports = r;
        }, function (t, e, n) {
          function r(t, e) {
            !o.isUndefined(t) && o.isUndefined(t["Content-Type"]) && (t["Content-Type"] = e);
          }
          var o = n(2),
            i = n(7),
            u = {
              "Content-Type": "application/x-www-form-urlencoded"
            },
            s = {
              adapter: function () {
                var t;
                return "undefined" != typeof XMLHttpRequest ? t = n(8) : "undefined" != typeof process && (t = n(8)), t;
              }(),
              transformRequest: [function (t, e) {
                return i(e, "Content-Type"), o.isFormData(t) || o.isArrayBuffer(t) || o.isBuffer(t) || o.isStream(t) || o.isFile(t) || o.isBlob(t) ? t : o.isArrayBufferView(t) ? t.buffer : o.isURLSearchParams(t) ? (r(e, "application/x-www-form-urlencoded;charset=utf-8"), t.toString()) : o.isObject(t) ? (r(e, "application/json;charset=utf-8"), JSON.stringify(t)) : t;
              }],
              transformResponse: [function (t) {
                if ("string" == typeof t) try {
                  t = JSON.parse(t);
                } catch (t) {}
                return t;
              }],
              timeout: 0,
              xsrfCookieName: "XSRF-TOKEN",
              xsrfHeaderName: "X-XSRF-TOKEN",
              maxContentLength: -1,
              validateStatus: function (t) {
                return t >= 200 && t < 300;
              }
            };
          s.headers = {
            common: {
              Accept: "application/json, text/plain, */*"
            }
          }, o.forEach(["delete", "get", "head"], function (t) {
            s.headers[t] = {};
          }), o.forEach(["post", "put", "patch"], function (t) {
            s.headers[t] = o.merge(u);
          }), t.exports = s;
        }, function (t, e, n) {
          var r = n(2);
          t.exports = function (t, e) {
            r.forEach(t, function (n, r) {
              r !== e && r.toUpperCase() === e.toUpperCase() && (t[e] = n, delete t[r]);
            });
          };
        }, function (t, e, n) {
          var r = n(2),
            o = n(9),
            i = n(12),
            u = n(13),
            s = n(14),
            a = n(10),
            c = "undefined" != typeof window && window.btoa && window.btoa.bind(window) || n(15);
          t.exports = function (t) {
            return new Promise(function (e, f) {
              var l = t.data,
                d = t.headers;
              r.isFormData(l) && delete d["Content-Type"];
              var p = new XMLHttpRequest(),
                h = "onreadystatechange",
                v = !1;
              if ("undefined" == typeof window || !window.XDomainRequest || "withCredentials" in p || s(t.url) || (p = new window.XDomainRequest(), h = "onload", v = !0, p.onprogress = function () {}, p.ontimeout = function () {}), t.auth) {
                var y = t.auth.username || "",
                  m = t.auth.password || "";
                d.Authorization = "Basic " + c(y + ":" + m);
              }
              if (p.open(t.method.toUpperCase(), i(t.url, t.params, t.paramsSerializer), !0), p.timeout = t.timeout, p[h] = function () {
                if (p && (4 === p.readyState || v) && (0 !== p.status || p.responseURL && 0 === p.responseURL.indexOf("file:"))) {
                  var n = "getAllResponseHeaders" in p ? u(p.getAllResponseHeaders()) : null,
                    r = {
                      data: t.responseType && "text" !== t.responseType ? p.response : p.responseText,
                      status: 1223 === p.status ? 204 : p.status,
                      statusText: 1223 === p.status ? "No Content" : p.statusText,
                      headers: n,
                      config: t,
                      request: p
                    };
                  o(e, f, r), p = null;
                }
              }, p.onerror = function () {
                f(a("Network Error", t, null, p)), p = null;
              }, p.ontimeout = function () {
                f(a("timeout of " + t.timeout + "ms exceeded", t, "ECONNABORTED", p)), p = null;
              }, r.isStandardBrowserEnv()) {
                var _ = n(16),
                  E = (t.withCredentials || s(t.url)) && t.xsrfCookieName ? _.read(t.xsrfCookieName) : void 0;
                E && (d[t.xsrfHeaderName] = E);
              }
              if ("setRequestHeader" in p && r.forEach(d, function (t, e) {
                void 0 === l && "content-type" === e.toLowerCase() ? delete d[e] : p.setRequestHeader(e, t);
              }), t.withCredentials && (p.withCredentials = !0), t.responseType) try {
                p.responseType = t.responseType;
              } catch (e) {
                if ("json" !== t.responseType) throw e;
              }
              "function" == typeof t.onDownloadProgress && p.addEventListener("progress", t.onDownloadProgress), "function" == typeof t.onUploadProgress && p.upload && p.upload.addEventListener("progress", t.onUploadProgress), t.cancelToken && t.cancelToken.promise.then(function (t) {
                p && (p.abort(), f(t), p = null);
              }), void 0 === l && (l = null), p.send(l);
            });
          };
        }, function (t, e, n) {
          var r = n(10);
          t.exports = function (t, e, n) {
            var o = n.config.validateStatus;
            n.status && o && !o(n.status) ? e(r("Request failed with status code " + n.status, n.config, null, n.request, n)) : t(n);
          };
        }, function (t, e, n) {
          var r = n(11);
          t.exports = function (t, e, n, o, i) {
            var u = new Error(t);
            return r(u, e, n, o, i);
          };
        }, function (t, e) {
          t.exports = function (t, e, n, r, o) {
            return t.config = e, n && (t.code = n), t.request = r, t.response = o, t;
          };
        }, function (t, e, n) {
          function r(t) {
            return encodeURIComponent(t).replace(/%40/gi, "@").replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
          }
          var o = n(2);
          t.exports = function (t, e, n) {
            if (!e) return t;
            var i;
            if (n) i = n(e);else if (o.isURLSearchParams(e)) i = e.toString();else {
              var u = [];
              o.forEach(e, function (t, e) {
                null !== t && void 0 !== t && (o.isArray(t) && (e += "[]"), o.isArray(t) || (t = [t]), o.forEach(t, function (t) {
                  o.isDate(t) ? t = t.toISOString() : o.isObject(t) && (t = JSON.stringify(t)), u.push(r(e) + "=" + r(t));
                }));
              }), i = u.join("&");
            }
            return i && (t += (-1 === t.indexOf("?") ? "?" : "&") + i), t;
          };
        }, function (t, e, n) {
          var r = n(2);
          t.exports = function (t) {
            var e,
              n,
              o,
              i = {};
            return t ? (r.forEach(t.split("\n"), function (t) {
              o = t.indexOf(":"), e = r.trim(t.substr(0, o)).toLowerCase(), n = r.trim(t.substr(o + 1)), e && (i[e] = i[e] ? i[e] + ", " + n : n);
            }), i) : i;
          };
        }, function (t, e, n) {
          var r = n(2);
          t.exports = r.isStandardBrowserEnv() ? function () {
            function t(t) {
              var e = t;
              return n && (o.setAttribute("href", e), e = o.href), o.setAttribute("href", e), {
                href: o.href,
                protocol: o.protocol ? o.protocol.replace(/:$/, "") : "",
                host: o.host,
                search: o.search ? o.search.replace(/^\?/, "") : "",
                hash: o.hash ? o.hash.replace(/^#/, "") : "",
                hostname: o.hostname,
                port: o.port,
                pathname: "/" === o.pathname.charAt(0) ? o.pathname : "/" + o.pathname
              };
            }
            var e,
              n = /(msie|trident)/i.test(navigator.userAgent),
              o = document.createElement("a");
            return e = t(window.location.href), function (n) {
              var o = r.isString(n) ? t(n) : n;
              return o.protocol === e.protocol && o.host === e.host;
            };
          }() : function () {
            return !0;
          };
        }, function (t, e) {
          function n() {
            this.message = "String contains an invalid character";
          }
          var r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
          n.prototype = new Error(), n.prototype.code = 5, n.prototype.name = "InvalidCharacterError", t.exports = function (t) {
            for (var e, o, i = String(t), u = "", s = 0, a = r; i.charAt(0 | s) || (a = "=", s % 1); u += a.charAt(63 & e >> 8 - s % 1 * 8)) {
              if ((o = i.charCodeAt(s += .75)) > 255) throw new n();
              e = e << 8 | o;
            }
            return u;
          };
        }, function (t, e, n) {
          var r = n(2);
          t.exports = r.isStandardBrowserEnv() ? {
            write: function (t, e, n, o, i, u) {
              var s = [];
              s.push(t + "=" + encodeURIComponent(e)), r.isNumber(n) && s.push("expires=" + new Date(n).toGMTString()), r.isString(o) && s.push("path=" + o), r.isString(i) && s.push("domain=" + i), !0 === u && s.push("secure"), document.cookie = s.join("; ");
            },
            read: function (t) {
              var e = document.cookie.match(new RegExp("(^|;\\s*)(" + t + ")=([^;]*)"));
              return e ? decodeURIComponent(e[3]) : null;
            },
            remove: function (t) {
              this.write(t, "", Date.now() - 864e5);
            }
          } : {
            write: function () {},
            read: function () {
              return null;
            },
            remove: function () {}
          };
        }, function (t, e, n) {
          function r() {
            this.handlers = [];
          }
          var o = n(2);
          r.prototype.use = function (t, e) {
            return this.handlers.push({
              fulfilled: t,
              rejected: e
            }), this.handlers.length - 1;
          }, r.prototype.eject = function (t) {
            this.handlers[t] && (this.handlers[t] = null);
          }, r.prototype.forEach = function (t) {
            o.forEach(this.handlers, function (e) {
              null !== e && t(e);
            });
          }, t.exports = r;
        }, function (t, e, n) {
          function r(t) {
            t.cancelToken && t.cancelToken.throwIfRequested();
          }
          var o = n(2),
            i = n(19),
            u = n(20),
            s = n(6);
          t.exports = function (t) {
            return r(t), t.headers = t.headers || {}, t.data = i(t.data, t.headers, t.transformRequest), t.headers = o.merge(t.headers.common || {}, t.headers[t.method] || {}, t.headers || {}), o.forEach(["delete", "get", "head", "post", "put", "patch", "common"], function (e) {
              delete t.headers[e];
            }), (t.adapter || s.adapter)(t).then(function (e) {
              return r(t), e.data = i(e.data, e.headers, t.transformResponse), e;
            }, function (e) {
              return u(e) || (r(t), e && e.response && (e.response.data = i(e.response.data, e.response.headers, t.transformResponse))), Promise.reject(e);
            });
          };
        }, function (t, e, n) {
          var r = n(2);
          t.exports = function (t, e, n) {
            return r.forEach(n, function (n) {
              t = n(t, e);
            }), t;
          };
        }, function (t, e) {
          t.exports = function (t) {
            return !(!t || !t.__CANCEL__);
          };
        }, function (t, e) {
          t.exports = function (t) {
            return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(t);
          };
        }, function (t, e) {
          t.exports = function (t, e) {
            return e ? t.replace(/\/+$/, "") + "/" + e.replace(/^\/+/, "") : t;
          };
        }, function (t, e) {
          function n(t) {
            this.message = t;
          }
          n.prototype.toString = function () {
            return "Cancel" + (this.message ? ": " + this.message : "");
          }, n.prototype.__CANCEL__ = !0, t.exports = n;
        }, function (t, e, n) {
          function r(t) {
            if ("function" != typeof t) throw new TypeError("executor must be a function.");
            var e;
            this.promise = new Promise(function (t) {
              e = t;
            });
            var n = this;
            t(function (t) {
              n.reason || (n.reason = new o(t), e(n.reason));
            });
          }
          var o = n(23);
          r.prototype.throwIfRequested = function () {
            if (this.reason) throw this.reason;
          }, r.source = function () {
            var t;
            return {
              token: new r(function (e) {
                t = e;
              }),
              cancel: t
            };
          }, t.exports = r;
        }, function (t, e) {
          t.exports = function (t) {
            return function (e) {
              return t.apply(null, e);
            };
          };
        }]);
      });
    }),
    i = ["ETIMEDOUT", "ECONNRESET", "EADDRINUSE", "ESOCKETTIMEDOUT", "ECONNREFUSED", "EPIPE"],
    u = ["ENOTFOUND", "ENETUNREACH", "UNABLE_TO_GET_ISSUER_CERT", "UNABLE_TO_GET_CRL", "UNABLE_TO_DECRYPT_CERT_SIGNATURE", "UNABLE_TO_DECRYPT_CRL_SIGNATURE", "UNABLE_TO_DECODE_ISSUER_PUBLIC_KEY", "CERT_SIGNATURE_FAILURE", "CRL_SIGNATURE_FAILURE", "CERT_NOT_YET_VALID", "CERT_HAS_EXPIRED", "CRL_NOT_YET_VALID", "CRL_HAS_EXPIRED", "ERROR_IN_CERT_NOT_BEFORE_FIELD", "ERROR_IN_CERT_NOT_AFTER_FIELD", "ERROR_IN_CRL_LAST_UPDATE_FIELD", "ERROR_IN_CRL_NEXT_UPDATE_FIELD", "OUT_OF_MEM", "DEPTH_ZERO_SELF_SIGNED_CERT", "SELF_SIGNED_CERT_IN_CHAIN", "UNABLE_TO_GET_ISSUER_CERT_LOCALLY", "UNABLE_TO_VERIFY_LEAF_SIGNATURE", "CERT_CHAIN_TOO_LONG", "CERT_REVOKED", "INVALID_CA", "PATH_LENGTH_EXCEEDED", "INVALID_PURPOSE", "CERT_UNTRUSTED", "CERT_REJECTED"],
    s = function (t) {
      return !t || !t.code || -1 !== i.indexOf(t.code) || -1 === u.indexOf(t.code);
    },
    a = e(function (t, e) {
      function n(t) {
        return !t.response && Boolean(t.code) && "ECONNABORTED" !== t.code && (0, h.default)(t);
      }
      function r(t) {
        return "ECONNABORTED" !== t.code && (!t.response || t.response.status >= 500 && t.response.status <= 599);
      }
      function o(t) {
        return !!t.config && r(t) && -1 !== y.indexOf(t.config.method);
      }
      function i(t) {
        return !!t.config && r(t) && -1 !== m.indexOf(t.config.method);
      }
      function u(t) {
        return n(t) || i(t);
      }
      function a() {
        return 0;
      }
      function c() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
          e = 100 * Math.pow(2, t);
        return e + .2 * e * Math.random();
      }
      function f(t) {
        var e = t[v] || {};
        return e.retryCount = e.retryCount || 0, t[v] = e, e;
      }
      function l(t, e) {
        return Object.assign({}, e, t[v]);
      }
      function d(t, e) {
        t.defaults.agent === e.agent && delete e.agent, t.defaults.httpAgent === e.httpAgent && delete e.httpAgent, t.defaults.httpsAgent === e.httpsAgent && delete e.httpsAgent;
      }
      function p(t, e) {
        t.interceptors.request.use(function (t) {
          return f(t).lastRequestTime = Date.now(), t;
        }), t.interceptors.response.use(null, function (n) {
          var r = n.config;
          if (!r) return Promise.reject(n);
          var o = l(r, e),
            i = o.retries,
            s = void 0 === i ? 3 : i,
            c = o.retryCondition,
            p = void 0 === c ? u : c,
            h = o.retryDelay,
            v = void 0 === h ? a : h,
            y = o.shouldResetTimeout,
            m = void 0 !== y && y,
            _ = f(r);
          if (p(n) && _.retryCount < s) {
            _.retryCount += 1;
            var E = v(_.retryCount, n);
            if (d(t, r), !m && r.timeout && _.lastRequestTime) {
              var g = Date.now() - _.lastRequestTime;
              r.timeout = Math.max(r.timeout - g - E, 1);
            }
            return r.transformRequest = [function (t) {
              return t;
            }], new Promise(function (e) {
              return setTimeout(function () {
                return e(t(r));
              }, E);
            });
          }
          return Promise.reject(n);
        });
      }
      Object.defineProperty(e, "__esModule", {
        value: !0
      }), e.isNetworkError = n, e.isRetryableError = r, e.isSafeRequestError = o, e.isIdempotentRequestError = i, e.isNetworkOrIdempotentRequestError = u, e.exponentialDelay = c, e.default = p;
      var h = function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        }(s),
        v = "axios-retry",
        y = ["get", "head", "options"],
        m = y.concat(["put", "delete"]);
      p.isNetworkError = n, p.isSafeRequestError = o, p.isIdempotentRequestError = i, p.isNetworkOrIdempotentRequestError = u, p.exponentialDelay = c, p.isRetryableError = r;
    }).default;
  "function" != typeof Object.assign && Object.defineProperty(Object, "assign", {
    value: function (t, e) {
      if (null == t) throw new TypeError("Cannot convert undefined or null to object");
      for (var n = Object(t), r = 1; r < arguments.length; r++) {
        var o = arguments[r];
        if (null != o) for (var i in o) Object.prototype.hasOwnProperty.call(o, i) && (n[i] = o[i]);
      }
      return n;
    },
    writable: !0,
    configurable: !0
  });
  e(function (e, n) {
    !function (t, n) {
      e.exports = n();
    }(0, function () {
      function e(t) {
        var e = typeof t;
        return null !== t && ("object" === e || "function" === e);
      }
      function n(t) {
        return "function" == typeof t;
      }
      function o() {
        return void 0 !== U ? function () {
          U(u);
        } : i();
      }
      function i() {
        var t = setTimeout;
        return function () {
          return t(u, 1);
        };
      }
      function u() {
        for (var t = 0; t < j; t += 2) (0, G[t])(G[t + 1]), G[t] = void 0, G[t + 1] = void 0;
        j = 0;
      }
      function s(t, e) {
        var n = this,
          r = new this.constructor(c);
        void 0 === r[X] && S(r);
        var o = n._state;
        if (o) {
          var i = arguments[o - 1];
          B(function () {
            return A(o, r, i, n._result);
          });
        } else w(n, r, t, e);
        return r;
      }
      function a(t) {
        var e = this;
        if (t && "object" == typeof t && t.constructor === e) return t;
        var n = new e(c);
        return m(n, t), n;
      }
      function c() {}
      function f() {
        return new TypeError("You cannot resolve a promise with itself");
      }
      function l() {
        return new TypeError("A promises callback cannot return that same promise.");
      }
      function d(t) {
        try {
          return t.then;
        } catch (t) {
          return z.error = t, z;
        }
      }
      function p(t, e, n, r) {
        try {
          t.call(e, n, r);
        } catch (t) {
          return t;
        }
      }
      function h(t, e, n) {
        B(function (t) {
          var r = !1,
            o = p(n, e, function (n) {
              r || (r = !0, e !== n ? m(t, n) : E(t, n));
            }, function (e) {
              r || (r = !0, g(t, e));
            }, "Settle: " + (t._label || " unknown promise"));
          !r && o && (r = !0, g(t, o));
        }, t);
      }
      function v(t, e) {
        e._state === K ? E(t, e._result) : e._state === J ? g(t, e._result) : w(e, void 0, function (e) {
          return m(t, e);
        }, function (e) {
          return g(t, e);
        });
      }
      function y(t, e, r) {
        e.constructor === t.constructor && r === s && e.constructor.resolve === a ? v(t, e) : r === z ? (g(t, z.error), z.error = null) : void 0 === r ? E(t, e) : n(r) ? h(t, e, r) : E(t, e);
      }
      function m(t, n) {
        t === n ? g(t, f()) : e(n) ? y(t, n, d(n)) : E(t, n);
      }
      function _(t) {
        t._onerror && t._onerror(t._result), R(t);
      }
      function E(t, e) {
        t._state === Y && (t._result = e, t._state = K, 0 !== t._subscribers.length && B(R, t));
      }
      function g(t, e) {
        t._state === Y && (t._state = J, t._result = e, B(_, t));
      }
      function w(t, e, n, r) {
        var o = t._subscribers,
          i = o.length;
        t._onerror = null, o[i] = e, o[i + K] = n, o[i + J] = r, 0 === i && t._state && B(R, t);
      }
      function R(t) {
        var e = t._subscribers,
          n = t._state;
        if (0 !== e.length) {
          for (var r = void 0, o = void 0, i = t._result, u = 0; u < e.length; u += 3) r = e[u], o = e[u + n], r ? A(n, r, o, i) : o(i);
          t._subscribers.length = 0;
        }
      }
      function b() {
        this.error = null;
      }
      function T(t, e) {
        try {
          return t(e);
        } catch (t) {
          return $.error = t, $;
        }
      }
      function A(t, e, r, o) {
        var i = n(r),
          u = void 0,
          s = void 0,
          a = void 0,
          c = void 0;
        if (i) {
          if ((u = T(r, o)) === $ ? (c = !0, s = u.error, u.error = null) : a = !0, e === u) return void g(e, l());
        } else u = o, a = !0;
        e._state !== Y || (i && a ? m(e, u) : c ? g(e, s) : t === K ? E(e, u) : t === J && g(e, u));
      }
      function C(t, e) {
        try {
          e(function (e) {
            m(t, e);
          }, function (e) {
            g(t, e);
          });
        } catch (e) {
          g(t, e);
        }
      }
      function O() {
        return W++;
      }
      function S(t) {
        t[X] = W++, t._state = void 0, t._result = void 0, t._subscribers = [];
      }
      function I() {
        return new Error("Array Methods must be provided an Array");
      }
      function x() {
        throw new TypeError("You must pass a resolver function as the first argument to the promise constructor");
      }
      function N() {
        throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
      }
      var D = void 0,
        L = D = Array.isArray ? Array.isArray : function (t) {
          return "[object Array]" === Object.prototype.toString.call(t);
        },
        j = 0,
        U = void 0,
        P = void 0,
        B = function (t, e) {
          G[j] = t, G[j + 1] = e, 2 === (j += 2) && (P ? P(u) : V());
        },
        q = "undefined" != typeof window ? window : void 0,
        k = q || {},
        F = k.MutationObserver || k.WebKitMutationObserver,
        M = "undefined" == typeof self && "undefined" != typeof process && "[object process]" === {}.toString.call(process),
        H = "undefined" != typeof Uint8ClampedArray && "undefined" != typeof importScripts && "undefined" != typeof MessageChannel,
        G = new Array(1e3),
        V = void 0;
      V = M ? function () {
        return process.nextTick(u);
      } : F ? function () {
        var t = 0,
          e = new F(u),
          n = document.createTextNode("");
        return e.observe(n, {
          characterData: !0
        }), function () {
          n.data = t = ++t % 2;
        };
      }() : H ? function () {
        var t = new MessageChannel();
        return t.port1.onmessage = u, function () {
          return t.port2.postMessage(0);
        };
      }() : void 0 === q && "function" == typeof t ? function () {
        try {
          var e = t("vertx");
          return U = e.runOnLoop || e.runOnContext, o();
        } catch (t) {
          return i();
        }
      }() : i();
      var X = Math.random().toString(36).substring(16),
        Y = void 0,
        K = 1,
        J = 2,
        z = new b(),
        $ = new b(),
        W = 0,
        Z = function () {
          function t(t, e) {
            this._instanceConstructor = t, this.promise = new t(c), this.promise[X] || S(this.promise), L(e) ? (this.length = e.length, this._remaining = e.length, this._result = new Array(this.length), 0 === this.length ? E(this.promise, this._result) : (this.length = this.length || 0, this._enumerate(e), 0 === this._remaining && E(this.promise, this._result))) : g(this.promise, I());
          }
          return t.prototype._enumerate = function (t) {
            for (var e = 0; this._state === Y && e < t.length; e++) this._eachEntry(t[e], e);
          }, t.prototype._eachEntry = function (t, e) {
            var n = this._instanceConstructor,
              r = n.resolve;
            if (r === a) {
              var o = d(t);
              if (o === s && t._state !== Y) this._settledAt(t._state, e, t._result);else if ("function" != typeof o) this._remaining--, this._result[e] = t;else if (n === Q) {
                var i = new n(c);
                y(i, t, o), this._willSettleAt(i, e);
              } else this._willSettleAt(new n(function (e) {
                return e(t);
              }), e);
            } else this._willSettleAt(r(t), e);
          }, t.prototype._settledAt = function (t, e, n) {
            var r = this.promise;
            r._state === Y && (this._remaining--, t === J ? g(r, n) : this._result[e] = n), 0 === this._remaining && E(r, this._result);
          }, t.prototype._willSettleAt = function (t, e) {
            var n = this;
            w(t, void 0, function (t) {
              return n._settledAt(K, e, t);
            }, function (t) {
              return n._settledAt(J, e, t);
            });
          }, t;
        }(),
        Q = function () {
          function t(e) {
            this[X] = O(), this._result = this._state = void 0, this._subscribers = [], c !== e && ("function" != typeof e && x(), this instanceof t ? C(this, e) : N());
          }
          return t.prototype.catch = function (t) {
            return this.then(null, t);
          }, t.prototype.finally = function (t) {
            var e = this,
              n = e.constructor;
            return e.then(function (e) {
              return n.resolve(t()).then(function () {
                return e;
              });
            }, function (e) {
              return n.resolve(t()).then(function () {
                throw e;
              });
            });
          }, t;
        }();
      return Q.prototype.then = s, Q.all = function (t) {
        return new Z(this, t).promise;
      }, Q.race = function (t) {
        var e = this;
        return new e(L(t) ? function (n, r) {
          for (var o = t.length, i = 0; i < o; i++) e.resolve(t[i]).then(n, r);
        } : function (t, e) {
          return e(new TypeError("You must pass an array to race."));
        });
      }, Q.resolve = a, Q.reject = function (t) {
        var e = new this(c);
        return g(e, t), e;
      }, Q._setScheduler = function (t) {
        P = t;
      }, Q._setAsap = function (t) {
        B = t;
      }, Q._asap = B, Q.polyfill = function () {
        var t = void 0;
        if (void 0 !== r) t = r;else if ("undefined" != typeof self) t = self;else try {
          t = Function("return this")();
        } catch (t) {
          throw new Error("polyfill failed because global object is unavailable in this environment");
        }
        var e = t.Promise;
        if (e) {
          var n = null;
          try {
            n = Object.prototype.toString.call(e.resolve());
          } catch (t) {}
          if ("[object Promise]" === n && !e.cast) return;
        }
        t.Promise = Q;
      }, Q.Promise = Q, Q;
    });
  }).polyfill();
  var c = Object.assign || function (t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = arguments[e];
        for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
      }
      return t;
    },
    f = function () {
      function t(t, e) {
        for (var n = 0; n < e.length; n++) {
          var r = e[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
        }
      }
      return function (e, n, r) {
        return n && t(e.prototype, n), r && t(e, r), e;
      };
    }(),
    l = o.create({
      baseURL: "https://mercury-ingest.wiwdata.com/v1/event",
      timeout: 4e3,
      headers: {
        "Content-Type": "application/json"
      }
    });
  return a(l, {
    retries: 5,
    retryCondition: function (t) {
      return !0;
    },
    retryDelay: function (t) {
      return 100;
    },
    shouldResetTimeout: !0
  }), function () {
    function t() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
      n(this, t), this.config = {
        environment: null
      }, this.identity = {
        accountId: null,
        userId: null,
        personId: null,
        origin: null
      }, this.config = c({}, this.config, e);
    }
    return f(t, [{
      key: "_buildKey",
      value: function (t) {
        return t.key || t.meta.accountId || this.identity.accountId || t.meta.personId || this.identity.personId;
      }
    }, {
      key: "_uuid",
      value: function () {
        function t() {
          return Math.floor(65536 * (1 + Math.random())).toString(16).substring(1);
        }
        return t() + t() + "-" + t() + "-" + t() + "-" + t() + "-" + t() + t() + t();
      }
    }, {
      key: "_buildEvent",
      value: function (t, e, n) {
        n.meta || (n.meta = {});
        var r = this._uuid(),
          o = this._buildKey(n);
        return o || console.error("Bad Mercury event key"), {
          key: o || r,
          payload: {
            name: t,
            uuid: r,
            tag: this.config.environment,
            timestamp: new Date().toISOString(),
            meta: this._buildMeta(n),
            fields: e
          }
        };
      }
    }, {
      key: "_buildMeta",
      value: function (t) {
        return {
          accountId: t.meta.accountId || this.identity.accountId ? (t.meta.accountId || this.identity.accountId).toString() : null,
          userId: t.meta.userId || this.identity.userId ? (t.meta.userId || this.identity.userId).toString() : null,
          personId: t.meta.personId || this.identity.personId ? (t.meta.personId || this.identity.personId).toString() : null,
          userAgent: navigator.userAgent,
          origin: t.meta.origin || this.identity.origin
        };
      }
    }, {
      key: "_send",
      value: function (t) {
        return l.post("", t);
      }
    }, {
      key: "track",
      value: function (t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        return this._send(this._buildEvent(t, e, n));
      }
    }, {
      key: "page",
      value: function () {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "web::pageView",
          r = {
            annotations: null,
            hash: window.location.hash,
            hostName: window.location.hostname,
            path: window.location.pathname,
            queryParams: window.location.search,
            referrer: document.referrer,
            sessionFlowId: null,
            timing: JSON.stringify(window.performance.timing)
          };
        return t = Object.assign({}, r, t), this._send(this._buildEvent(n, t, e));
      }
    }, {
      key: "interaction",
      value: function () {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "web::onInteraction",
          r = {
            annotations: null,
            hash: window.location.hash,
            hostName: window.location.hostname,
            path: window.location.pathname,
            queryParams: window.location.search
          };
        return t = Object.assign({}, r, t), this._send(this._buildEvent(n, t, e));
      }
    }, {
      key: "identify",
      value: function (t, e, n, r, o) {
        t = String(t), e = String(e), n = String(n), this.identity = {
          accountId: t,
          userId: e,
          personId: n,
          origin: r
        }, this.config.environment = o;
      }
    }]), t;
  }();
});